import { useTranslation } from "react-i18next";

function SecurityFailedIncorrectDocument() {
  const { t } = useTranslation("security");

  return (
    <>
      <p>
        {t("security:kyc-failed-incorrect-document-intro")}
        {/* We regret to inform you that your recent submission for the verification
        process has been unsuccessful due to a mismatch between the selected
        document type and the document you provided. Our team conducted a
        thorough review of your submission, and unfortunately, the document you
        submitted does not align with the document type you indicated or our
        allowed document types for verification. */}
      </p>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-incorrect-document-header")}
        {/* The specific issue identified with your submission is: */}
      </p>
      <div class="w-full h-4" />
      <p>
        <strong>
          {t("security:kyc-failed-incorrect-document-list-header-1")}
          {" "}
          {/* Document Type Mismatch: */}
        </strong>
        {t("security:kyc-failed-incorrect-document-list-item-1")}
        {/* The document type you selected during the process does not match the
        document you provided. Verification requires specific document types,
        such as government-issued ID cards, passports, or driver's licenses,
        depending on our guidelines. Your submission did not align with these
        requirements. */}
      </p>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-incorrect-document-instructions")}
        {/* To address this issue and proceed with your verification, please take
        the following steps: */}
      </p>
      <ul>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-incorrect-document-list-header-2")}
            {" "}
            {/* Resubmit the Correct Document: */}
          </strong>
          {t("security:kyc-failed-incorrect-document-list-item-2")}
          {/* Ensure that you provide the correct document type that aligns with our
          guidelines. Please carefully review our document requirements and
          select the appropriate document for verification. */}
        </li>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-incorrect-document-list-header-3")}
            {" "}
            {/* Double-Check Document Information: */}
          </strong>
          {t("security:kyc-failed-incorrect-document-list-item-3")}
          {/* Make sure that the document you submit contains accurate and
          up-to-date information that matches your registration details. */}
        </li>
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-incorrect-document-ending")}
        {/* We look forward to receiving the correct document for your verification. */}
      </p>
    </>
  );
}

export default SecurityFailedIncorrectDocument;
